import { parseDataTableData } from '@shared/helpers/data-tables';

/**
 * Extract keys from a JSON string.
 * @param dataString
 * @returns
 */
export const extractKeysFromData = (dataString: string): string[] => {
  try {
    const parsed = parseDataTableData(dataString);
    const allKeys = new Set<string>();
    parsed.forEach((item) => {
      if (typeof item === 'object' && item !== null) {
        Object.keys(item).forEach((key) => allKeys.add(key));
      }
    });

    return Array.from(allKeys).sort();
  } catch {
    return [];
  }
};
